var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAddOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 11V7.00195C13 6.73674 12.8946 6.48238 12.7071 6.29485C12.5195 6.10731 12.2652 6.00195 12 6.00195C11.7347 6.00195 11.4804 6.10731 11.2928 6.29485C11.1053 6.48238 11 6.73674 11 7.00195V11H7.00195C6.73674 11 6.48238 11.1053 6.29485 11.2928C6.10731 11.4804 6.00195 11.7347 6.00195 12C6.00195 12.2652 6.10731 12.5195 6.29485 12.7071C6.48238 12.8946 6.73674 13 7.00195 13H11V16.998C11 17.2632 11.1053 17.5175 11.2928 17.7051C11.4804 17.8926 11.7347 17.998 12 17.998C12.2652 17.998 12.5195 17.8926 12.7071 17.7051C12.8946 17.5175 13 17.2632 13 16.998V13H16.998C17.2632 13 17.5175 12.8946 17.7051 12.7071C17.8926 12.5195 17.998 12.2652 17.998 12C17.998 11.7347 17.8926 11.4804 17.7051 11.2928C17.5175 11.1053 17.2632 11 16.998 11H13Z",
    fill: "#F1592A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddOrange);
export default __webpack_public_path__ + "static/media/ic_add_orange.50b49ef0815a8e79461fb0403d252772.svg";
export { ForwardRef as ReactComponent };